<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../components/widgets/loader";
import Forms from "../../../mixins/Forms";
import Dates from "../../../mixins/Dates";

let _ = require('lodash');

import axios from 'axios';

/**
 * View ticket component
 */
export default {
  page: {
    title: "All SLA Breaches",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Forms, Dates],
  components: {Layout, PageHeader, Loader},
  data() {
    return {
      title: "All SLA Breaches",
      items: [
        {
          text: "SLA Breaches",
          href: "#"
        },
        {
          text: "All SLA Breaches",
          active: true
        }
      ],

      serverErrors: [],
      isLoading: false,
      slaBreaches: null,

      statusOptions: [
        {
          label: 'Show all',
          value: 'all'
        },
        {
          label: 'Unresolved',
          value: 'unresolved'
        },
        {
          label: 'Resolved',
          value: 'resolved'
        }
      ],

      filters: {
        results_per_page: 30,
        status: 'all'
      }
    };
  },
  computed: {
    slaBreachResults() {
      if (this.slaBreaches) {
        return this.slaBreaches.data;
      }
      return [];
    }
  },
  methods: {
    determineSearchParams(page) {
      let params = {
        page: page,
        results_per_page: this.filters.results_per_page
      };

      if (this.filters.status !== null) {
        params['status'] = this.filters.status;
      }

      return params;
    },

    loadSlaBreaches: _.debounce(function (page = 1) {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoading = true;
      axios.post(API_BASE + '/sla-breaches/search', vm.determineSearchParams(page)).then(r => {
        vm.slaBreaches = r.data;
        vm.isLoading = false;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    }),

    setup() {
      this.loadSlaBreaches();
    }
  },
  watch: {
    '$route': 'setup',
    filters: {
      handler: function () {
        this.loadSlaBreaches();
      },
      deep: true
    }
  },
  created() {
    this.setup();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>

    <div class="row">
      <div class="col-lg-9">
        <div class="card">
          <div class="card-body">
            <div v-if="isLoading" class="text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>

            <div v-if="!isLoading" class="table-responsive mb-0">
              <table class="table mb-0 table-centered">
                <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>Ticket</th>
                  <th>AXUM Booking ID</th>
                  <th>SLA</th>
                  <th>Flagged At</th>
                  <th>Resolved At</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="slaBreach in slaBreachResults">
                  <th scope="row">{{ slaBreach.id }}</th>
                  <td>{{ slaBreach.ticket.subject ? slaBreach.ticket.subject : '-' }}</td>
                  <td>{{ slaBreach.ticket.axum_booking_id ? slaBreachResults.ticket.axum_booking_id : '-' }}</td>
                  <td>{{ slaBreach.sla ? slaBreach.sla + ' mins' : '-' }}</td>
                  <td>{{ slaBreach.flagged_at ? displayTimestamp(slaBreach.flagged_at) : '-' }}</td>
                  <td>{{ slaBreach.resolved_at ? displayTimestamp(slaBreach.resolved_at) : '-' }}</td>
                  <td class="text-right">
                    <!-- Button trigger modal -->
                    <button
                        type="button"
                        class="btn btn-itg btn-itg btn-sm"
                        @click="$router.push('/tickets/'+slaBreach.ticket_id)"
                    >
                      View
                    </button>
                  </td>
                </tr>
                <tr v-if="slaBreachResults.length === 0">
                  <th scope="row" colspan="7">
                    <span class="text-danger">No results</span>
                  </th>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

        <pagination v-if="!(isLoading) && slaBreaches" :data="slaBreaches" :limit="8"
                    @pagination-change-page="loadSlaBreaches"></pagination>
      </div>
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body p-4">
            <!-- Results per page -->
            <div class="form-group mb-3">
              <label for="results_per_page">Results To Show</label>
              <v-select v-model="filters.results_per_page" :clearable="false"
                        :options="[10,20,30,40,50,60,70,80,90,100]"></v-select>
            </div>
            <!-- / Results per page -->

            <!-- Status -->
            <div class="form-group mb-3">
              <label for="status">Status</label>
              <v-select v-model="filters.status" label="label" placeholder="Show all"
                        :reduce="option => option.value"
                        :options="statusOptions"></v-select>
            </div>
            <!-- / Status -->
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.main-content {
  overflow: visible;
}
</style>
